import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const qualys = defineConnector({
  identifier: "qualys",
  name: "Qualys",
  tagLine: "Cloud security and compliance",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://qualysapi\\.[^/]+\\.qualys\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Select your Qualys platform",
      items: [
        {
          kind: "select",
          label: "Platform URL",
          required: true,
          target: { kind: "configuration", field: "platform" },
          options: [
            { value: "qualysapi.qualys.com", label: "US Platform 1" },
            { value: "qualysapi.qg2.apps.qualys.com", label: "US Platform 2" },
            { value: "qualysapi.qg3.apps.qualys.com", label: "US Platform 3" },
            { value: "qualysapi.qg4.apps.qualys.com", label: "US Platform 4" },
            { value: "qualysapi.qualys.eu", label: "EU Platform 1" },
            { value: "qualysapi.qg2.apps.qualys.eu", label: "EU Platform 2" },
            { value: "qualysapi.qg1.apps.qualys.in", label: "India Platform" },
            { value: "qualysapi.qg1.apps.qualys.ca", label: "Canada Platform" },
            { value: "qualysapi.qg1.apps.qualys.ae", label: "UAE Platform" },
          ],
          defaultValue: "qualysapi.qualys.com",
          helperText: "Select the Qualys platform your account uses.",
        },
      ],
    },
    {
      title: "Get your Qualys credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Use your Qualys username and password, or create API credentials in **Administration > Users > API**.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ platform }) => `https://${platform}/api/2.0/fo/scan/`,
  },
});
